import React from 'react';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import TabItem from '../../../@types/tab-item';
import {TabLabel} from './TabLabel.component';

interface TabBarProps {
    tabs: TabItem[];
    activeIndex: number;
    onTabChange: (event: React.SyntheticEvent, index: number) => void;
    onTabClose: (event: React.SyntheticEvent, tab: TabItem) => void;
    componentId: string;
}

/**
 * TabBar component manages the tab strip UI
 */
export const TabBar: React.FC<TabBarProps> = ({ 
    tabs, 
    activeIndex, 
    onTabChange, 
    onTabClose,
    componentId 
}) => {
    return (
        <Tabs
            id={`tab-editor-${componentId}`}
            variant="scrollable"
            scrollButtons="auto"
            value={activeIndex}
            onChange={onTabChange}
            sx={{
                minHeight: '36px',
                overflowX: 'auto',
                backgroundColor: tabs.length > 0 ? '#E5E4E2' : '#fff',
                '& .MuiTabs-indicator': {
                    display: 'none',
                },
                '& .MuiTab-root': {
                    minHeight: '36px',
                    padding: '6px 12px',
                    borderRight: '1px solid #ccc',
                    '&:hover:not(.Mui-selected)': {
                        backgroundColor: '#d5d4d2',
                    },
                },
                '& .Mui-selected': {
                    backgroundColor: '#fff',
                    borderRadius: '8px 8px 0px 0px',
                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.75)',
                    borderBottom: 'none',
                    borderLeft: '2px solid #E5E4E2',
                    borderRight: '2px solid #E5E4E2',
                    borderTop: '2px solid #E5E4E2',
                },
                '& .MuiTabs-scrollButtons': {
                    border: '1px solid #bdbdbd',
                    borderRadius: '4px',
                    backgroundColor: '#fff',
                    color: '#333',
                    minWidth: '32px',
                    minHeight: '32px',
                    margin: '0 4px',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
                    '&:hover': {
                        backgroundColor: '#f5f5f5',
                    },
                    '&.Mui-disabled': {
                        opacity: 0.3,
                    },
                },
            }}
        >
            {tabs.map((tab: TabItem) => (
                <Tab 
                    key={tab.index}
                    id={`tab-editor-tab-${componentId}-${tab.index}`}
                    tabIndex={0}
                    aria-label={`tab ${tab.label} at index ${tab.index}`}
                    aria-controls={`tab-editor-tab-${componentId}-${tab.index}-tabpanel`}
                    sx={{
                        backgroundColor: '#E5E4E2'
                    }}
                    label={
                        <TabLabel 
                            tab={tab}
                            isActive={tab.index === activeIndex}
                            onClose={(event) : void => onTabClose(event, tab)}
                        />
                    }
                    iconPosition='end'
                    disableRipple
                />
            ))}
        </Tabs>
    );
};